/*
eslint-disable react/prop-types
*/
import React, { useState, useEffect } from 'react';
import styled, { withTheme } from 'styled-components/macro';
import { SubWebWarnings } from '@uaveiro/ui';

// eslint-disable-next-line no-unused-vars
const SubWebWarningsModule = ({ data, ...props }) => {

  const { lang, tabs } = props
  const [shouldUpdateData, setShouldUpdateData] = useState(true);
  const [state, setState] = useState({
    isLoading: true,
    hasError: false,
    data: [],
    activeTab: 1,
    page: 3,
    totalPages: 0
  });


  const onFilterData = (activeTab = 1, page = 3) => {

    setShouldUpdateData(true);
    setState(prevState => ({
      ...prevState,
      page: 3,
      totalPages: 0
    }));

    const [content] = data.filter(item => item.id === activeTab);

    if (content !== undefined) {
      const list = content.list.filter((item, i) => i <= page && item);

      setState(prevState => ({
        ...prevState,
        isLoading: false,
        data: list,
        activeTab: content.id,
        page,
        totalPages: content.list.length
      }));
    } else {
      setState(prevState => ({
        ...prevState,
        isLoading: false,
        data: [],
        activeTab: 1,
        page: 3,
        totalPages: 0
      }));
    }
  };

  useEffect(() => {
 

    /* if (!shouldUpdateData) {
      return
    } */

    onFilterData(state.activeTab);
    setShouldUpdateData(false)
  }, [shouldUpdateData]);

  useEffect(() => {
    onFilterData(state.activeTab, state.page + 3);
  }, [data]);

  const onChangeTab = id => {
    onFilterData(id);
  };

  const onHandleMore = () => {
    onFilterData(state.activeTab, state.page + 3);
  };

  const departmentProps = {
    lang,
    tabs,
    onChangeTab,
    action: {
      text: lang === 'pt' ? 'ver mais' : 'see more',
      show: state.page + 1 < state.totalPages,
      onClick: onHandleMore
    },
    ...state,
    ...props
  };

  return (
    <Wrapper>
      <SubWebWarnings {...departmentProps} />
    </Wrapper>
  )
}

SubWebWarningsModule.propTypes = {
};

SubWebWarningsModule.defaultProps = {
}

const Wrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.greyLight};
`;

export default withTheme(SubWebWarningsModule);
